import { z } from "zod";
import { Id } from "../common/ids.js";
import { defineRoute } from "../http/route.js";
import { OpsEnterpriseSummary } from "./ops-verification.routes.js";
/**
 * Support's enterprise lookup (ADM-5, card 080; owner, 2026-10-04): read-only, without the verification cases the
 * reviewers' routes show, and with nothing to change. Every call is audited as an operator's (`ops.call`).
 */
const Support = { surface: "operator", auth: "operator", permission: "ops:support.read" };
export const listSupportEnterprises = defineRoute({
    ...Support,
    id: "ops.support.enterprises.list",
    method: "GET",
    path: "/v1/ops/support/enterprises",
    marks: [],
    summary: "Enterprises by name or registration number, newest first",
    prd: ["ADM-5"],
    request: { query: z.object({ q: z.string().trim().min(1).max(100).optional() }) },
    responses: {
        200: { description: "Enterprises", schema: z.object({ items: z.array(OpsEnterpriseSummary) }) },
    },
    errors: ["AUTH_REQUIRED", "PERMISSION_DENIED"],
});
export const getSupportEnterprise = defineRoute({
    ...Support,
    id: "ops.support.enterprises.get",
    method: "GET",
    path: "/v1/ops/support/enterprises/{enterpriseId}",
    marks: [],
    summary: "One enterprise and its count of active members; no verification cases",
    prd: ["ADM-5"],
    request: { params: z.object({ enterpriseId: Id }) },
    responses: {
        200: {
            description: "The enterprise",
            schema: z.object({ enterprise: OpsEnterpriseSummary, activeMembers: z.number().int().nonnegative() }),
        },
    },
    errors: ["AUTH_REQUIRED", "PERMISSION_DENIED", "NOT_FOUND"],
});
export const opsSupportRoutes = [listSupportEnterprises, getSupportEnterprise];
//# sourceMappingURL=ops-support.routes.js.map